import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция загрузки списка шаблонов
 */
export const useLoadCabinetAdminConfiguratorTemplates = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/cabinets/${route.params.object_id}/admin/configurator/templates`)

  const queryKey = computed(() => [
    'load_cabinet_admin_configurator_templates',
    route.params.object_id,
  ])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
